/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DevicesRequestBuilderRequestsMetadata, type DevicesRequestBuilder } from './devices/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/{salesRepId}
 */
export interface WithSalesRepItemRequestBuilder extends BaseRequestBuilder<WithSalesRepItemRequestBuilder> {
    /**
     * The devices property
     */
    get devices(): DevicesRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithSalesRepItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/{salesRepId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithSalesRepItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithSalesRepItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    devices: {
        requestsMetadata: DevicesRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
